import { render } from "./CoffersShop.vue?vue&type=template&id=78b8cd30&scoped=true"
import script from "./CoffersShop.vue?vue&type=script&lang=js"
export * from "./CoffersShop.vue?vue&type=script&lang=js"

import "./CoffersShop.vue?vue&type=style&index=0&id=78b8cd30&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-78b8cd30"

export default script